import React from "react";
import { Redirect } from "react-router-dom";
import { CCard, CCardBody } from '@coreui/react';

//** Libs */
import { SuccessMessage } from "../../../utils/Messages";
import BaseComponent from "../../../shared/baseComponent";
import Table from "../../../components/ui-components/Table";
import { NavigatePath } from "../../../navigation/NavigationLib";

//** Service */
import UserDomainServices from "../../../services/domainServices/userDomainServices";


export default class User extends BaseComponent {
    constructor(props) {
        super(props);
        this.userServices = new UserDomainServices();
        this.state = {
            pagination: this.userServices.pagination,
            setIsLoad: false,
            userList: [],
            redirect: null,
        }
        this.userServices.onUpdateState = this.updateState.bind(this);
        this.userServices.onActionCall = this.onActionCall.bind(this);
    }

    componentDidMount() {
        document.title = "IMS - Users";
        this.userServices.onGetRequests(this.state.pagination);
    }

    // *** Other function **//
    onActionCall = (type, data) => {
        switch (type) {
            case "Edit":
                let editUserList = [...this.state.userList];
                this.setState({ redirect: NavigatePath("UserDetail", [editUserList[data].userId]) });
                break;

            case "Delete":
                let deleterUserList = [...this.state.userList];
                this.userServices.apiService.swalServices.Confirm(SuccessMessage.Confirm_Question.replace('{0}', 'user'), SuccessMessage.Confirm_Delete.replace('{0}', 'user'), "Delete", "Cancel")
                    .then((res) => {
                        if (res) {
                            let deletItem = {
                                id: deleterUserList[data].userId
                            };
                            this.userServices.onDeleteUsers(deletItem);
                        }
                    });
                break;
        }
    };

    getSearchValue(value) {
    }

    render() {
        if (this.state.redirect != null) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <>
                <CCard className="shadow">
                    <CCardBody className="py-5">
                        <Table columns={this.userServices.gridColmns}
                            rows={this.state.userList}
                            totalCount={this.state.totalCount}
                            sortingColumns={[]}
                            getList={this.userServices.onGetRequests.bind(this)}
                            pagination={this.state.pagination}
                            isLoading={this.state.setIsLoad}
                            redirectToAdd={this.userServices.redirectToAdd.bind(this)}
                            customScope={[
                                {
                                    column: 'Actions',
                                    renderTableData: this.userServices.gridActionCol.bind(this)
                                },
                                {
                                    column: 'IsActive',
                                    renderTableData: this.userServices.gridCheckBoxCol.bind(this)
                                }
                            ]}
                            isAddUser={true}
                            getSearchValue={this.getSearchValue.bind(this)}
                        />
                    </CCardBody>
                </CCard>
            </>
        )
    }
}

